import React from 'react';
import AuthLayout from "../../Components/Layouts/AuthLayout";
import {NavLink, Outlet, useNavigate} from "react-router-dom";


const JobSettings = () => {
    const navigate = useNavigate();
    return (
        <>
            <AuthLayout>

                <div className="job-setting px-3 pt-3 bg-white">
                    <div className="bg-white px-3 pt-3 pb-0 mb-0">


                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(-1)}
                        className="text-decoration-none fw-bold text-secondary">
                         <i className="bi bi-arrow-left border-primary"></i> Back
                    </span>
                    <div className="d-flex justify-content-between mt-3">
                        <div className="mb-3">
                            <h4 className="general-header">Job Settings</h4>
                        </div>

                    </div>

                    <nav className="tab-nav bg-white">
                        <NavLink
                            to={`job-type`}
                            className={({ isActive }) => (isActive ? "tab active" : "tab")}
                        >
                            JOB TYPE
                        </NavLink>
                        <NavLink
                            to={`job-application`}
                            className={({ isActive }) => (isActive ? "tab active" : "tab")}
                        >
                            JOB APPLICATION QUESTIONS
                        </NavLink>
                        <NavLink
                            to="edit-field"
                            className={({ isActive }) => (isActive ? "tab active" : "tab")}
                        >
                            EDIT FIELDS
                        </NavLink>
                        <NavLink
                            to="salary-type"
                            className={({ isActive }) => (isActive ? "tab active" : "tab")}
                        >
                            SALARY OR PAYMENT TYPE
                        </NavLink>
                    </nav>
                    </div>
                    <div className="tab-content pt-0 mt-0">
                        {/* Pass validJobId to all child routes */}
                        <Outlet />
                    </div>
                </div>
            </AuthLayout>

        </>
    );
};

export default JobSettings;